import { PublicationStatusIndicator } from '@/components/publication/PublicationStatusIndicator';

/**
 * Item Editor publications tab. LAX-10152 replaced the AngularJS
 * {@code PublicationStatusController} island with the React indicator.
 */
const ItemPublicationsStatus = ({ primaryKey }: { primaryKey: string }) => (
    <PublicationStatusIndicator primaryKey={primaryKey} />
);

export { ItemPublicationsStatus };
